import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { PaginationResponse } from "../../types/Pagination";
import {
  VehiclePricingRequest,
  VehiclePricingRequestSearchFilters,
} from "../../types/VehiclePricingRequest";

export const searchDealerPricingRequests = (
  filters: VehiclePricingRequestSearchFilters | null,
  options: APQueryOptions = {}
) => {
  const { nextPageLink, ...otherFilters } = filters || {};

  const { fetchWithAuth } = useApi();
  const { defaultOnMutateError, defaultOnMutateSuccess, isQueryEnabled } =
    useAPQuery();

  return useQuery({
    queryKey: ["searchDealerPricingRequests", filters],
    queryFn: (): Promise<PaginationResponse<VehiclePricingRequest>> => {
      return fetchWithAuth<PaginationResponse<VehiclePricingRequest>>(
        "searchDealerPricingRequests",
        undefined,
        {
          requestOptions: {
            method: "post",
            body: filters
              ? JSON.stringify({
                  ...otherFilters,
                  nextPage: nextPageLink ?? undefined,
                })
              : undefined,
          },
        }
      );
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    enabled: isQueryEnabled(options),
    keepPreviousData: options.keepPreviousData,
  });
};
